export const readFileContent = async (file: File) => {
    if (typeof file.text === 'function') {
        try {
            return await file.text();
        } catch (error) {
            console.error(error);
        }
    }

    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            resolve(typeof reader.result === 'string' ? reader.result : '');
        };
        reader.onerror = () => {
            reject(reader.error ?? new Error('Could not read selected file.'));
        };
        reader.readAsText(file);
    });
};
